import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c5042f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OkTabs__container" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["OkTabs", { 'OkTabs--sub': _ctx.isSubTabs }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["OkTabs__tab", { 'tab--active': _ctx.isTabSelected(tab) }]),
          key: tab.id,
          onClick: ($event: any) => (_ctx.onSelect(tab))
        }, [
          (_ctx.$slots['tab'])
            ? _renderSlot(_ctx.$slots, "tab", {
                key: 0,
                tab: tab
              }, undefined, true)
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(tab.name), 1)
              ], 64))
        ], 10, _hoisted_2))
      }), 128))
    ])
  ], 2))
}